<div class="input-bar-wrapper">
    @if (completion()) {
        <!-- Sits behind the input, which is transparent. `.ghost-typed` is invisible but takes
             up the width of what has been typed, which is what puts the suffix in the right
             place without measuring any text. -->
        <div #ghostOverlay class="ghost-overlay" aria-hidden="true">
            <span class="ghost-typed">{{ inputText }}</span
            ><span class="ghost-suffix">{{ completion() }}</span>
        </div>
    }

    <input
        #inputBar
        role="combobox"
        aria-label="Ask me anything"
        aria-autocomplete="list"
        [attr.aria-expanded]="showSuggestions()"
        [attr.aria-controls]="showSuggestions() ? listboxId : null"
        [attr.aria-activedescendant]="activeOptionId()"
        [placeholder]="isGenerating ? 'Generating...' : placeholder()"
        [readonly]="isGenerating"
        [(ngModel)]="inputText"
        (ngModelChange)="onInputChange($event)"
        [maxLength]="10000"
        (keydown.enter)="onEnterKeydown($event)"
        (keydown.arrowdown)="moveHighlight(1, $event)"
        (keydown.arrowup)="moveHighlight(-1, $event)"
        (keydown.escape)="onEscapeKeydown($event)"
        (keydown.tab)="onTabKeydown($event)"
        (scroll)="syncGhostScroll()"
        (blur)="onBlur()"
    />

    <div class="submit-container">
        @if (!isGenerating) {
            <span>
                <hive-button
                    size="smallest"
                    title="Stop"
                    [icon]="faArrowRight"
                    [disabled]="isSubmitDisabled()"
                    (click)="clickSubmit()"
                />
            </span>
        } @else {
            <span class="stop-container">
                <hive-button size="smallest" title="Stop" [icon]="faSquare" (click)="clickStop()" />
            </span>
        }
    </div>

    @if (showSuggestions()) {
        <!-- Opens away from the edge the bar sits against: down under the landing ask bar, up from
             the conversation footer and side panel, which sit at the bottom of their container. -->
        <ul
            class="suggestions"
            role="listbox"
            aria-label="Suggested questions"
            [id]="listboxId"
            [class.below]="isLandingAskBar"
            [class.above]="!isLandingAskBar"
            (mouseleave)="activeIndex.set(-1)"
        >
            @for (question of suggestions(); track question.id; let i = $index) {
                <!-- mousedown is swallowed so the click does not first blur the input, which would
                     close the list before the click lands. -->
                <li
                    class="suggestion"
                    role="option"
                    [id]="optionId(i)"
                    [class.active]="i === activeIndex()"
                    [attr.aria-selected]="i === activeIndex()"
                    (mousedown)="$event.preventDefault()"
                    (mouseenter)="activeIndex.set(i)"
                    (click)="selectSuggestion(question)"
                >
                    {{ question.text }}
                </li>
            }
        </ul>
    }
</div>

<div class="ai-disclaimer" [class.landing]="isLandingAskBar">
    Generative AI is Experimental. Please validate your answers.
</div>
